import Header from '~/theme/layout/Header';

type BookHeader = {
  children?: React.ReactNode;
};

const BookHeader: React.FC<BookHeader> = ({ children }) => <Header style={{ paddingRight: '16px' }}>{children}</Header>;

export default BookHeader;
